import { useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useForm } from "react-hook-form";

import { duplicateTicket } from "./ticketsApi";
import FormGroup from "../../common/components/form/FormGroup";

interface TicketDuplicateFormData {
  title: string;
}

interface TicketDuplicateFormProps {
  id: string;
  title: string;
  onSubmit: (id: string) => void;
  onCancel: () => void;
}

export default function TicketDuplicateForm(props: TicketDuplicateFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<TicketDuplicateFormData>({ defaultValues: { title: `${props.title} (Duplicat)` } });
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data: TicketDuplicateFormData) => {
    setIsLoading(true);
    const newTicket = await duplicateTicket(props.id, data.title);
    props.onSubmit(newTicket.id);
    setIsLoading(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormGroup label="Titlul noului tichet" errorMessage={errors.title?.message}>
        <InputText placeholder="Titlu tichet" {...register("title", { required: "Titlu tichet este obligatoriu" })} />
      </FormGroup>
      <div className="flex justify-content-end gap-2">
        <Button type="button" label="Inapoi" text severity="secondary" onClick={props.onCancel}></Button>
        <Button type="submit" label="Duplica" icon="pi pi-save" loading={isLoading} disabled={isLoading}></Button>
      </div>
    </form>
  );
}
